module.exports = __webpack_public_path__ + "static/media/texture (10).5f6f95bd.jpg";